<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-photos"
  [activeStep]="1"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="
    'activity_creation.photos.section.description' | translate
  "
  [sectionTitle]="'activity_creation.photos.section.title' | translate"
  [tipsConfig]="tipsConfig"
  (formSubmit)="submit($event)"
>
  <app-form-control
    [title]="'activity_creation.photos.photo.title' | translate"
    [isExternalLabel]="true"
    [errorMessages]="errorMessages('photo')"
  >
    <app-form-image
      #controlChild
      formControlName="photo"
      class="organizer-activity-creation-page-photos__photo"
      [aspectRatio]="imageAspectRatio"
    ></app-form-image>
  </app-form-control>
  <p
    *appIsEnabled="toggleNameEnum.ActivityCreationPhotoExample"
    class="body-sm mb-3"
  >
    {{ 'activity_creation.photos.photo.example' | translate }}
  </p>

  <p class="mb-3">
    {{ 'activity_creation.photos.photo.default.description' | translate }}
  </p>

  <button
    app-vtmn-play-button
    type="button"
    [type]="ctaButtonType.Button"
    (click)="useDefaultPhoto()"
  >
    {{ 'activity_creation.photos.photo.default.button' | translate }}
  </button>
</app-organizer-shared-form-wrapper>
